export default "__VITE_ASSET__9968740e__"